import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard, SuperAdminGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------
const UploadsPage = lazy(() => import('src/pages/uploads'));
const FuzzyMatchResultsPage = lazy(() => import('src/pages/uploads/fuzzy-match-results'));
const TagUploadPage = lazy(() => import('src/pages/uploads/tag-upload'));
const ContactUploadPage = lazy(() => import('src/pages/uploads/contact-upload'));
const VolunteerUploadPage = lazy(() => import('src/pages/uploads/volunteer-upload'));
const FinalizeUploadProgressPage = lazy(() => import('src/pages/uploads/finalize-upload-progress'));
const DonorUploadPage = lazy(() => import('src/pages/uploads/donor-upload'));
const CopyTagPage = lazy(() => import('src/pages/uploads/copy-tag'));

// ----------------------------------------------------------------------

export const uploadsRoutes = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { path: 'uploads', element: <UploadsPage />, index: true },
      { path: 'uploads/:uploadId/results', element: <FuzzyMatchResultsPage /> },
      { path: 'uploads/tags', element: <TagUploadPage /> },
      { path: 'uploads/contacts', element: <ContactUploadPage /> },
      { path: 'uploads/volunteers', element: <VolunteerUploadPage /> },
      { path: 'uploads/:uploadId/finalize', element: <FinalizeUploadProgressPage /> },
      { path: 'uploads/donors', element: <DonorUploadPage /> },
      {
        path: 'uploads/copy-tag',
        element: (
          <SuperAdminGuard>
            <CopyTagPage />
          </SuperAdminGuard>
        ),
      },
    ],
  },
];
